// !(function (e) {
//   var n = {};
//   function t(o) {
//     if (n[o]) return n[o].exports;
//     var r = (n[o] = { i: o, l: !1, exports: {} });
//     return e[o].call(r.exports, r, r.exports, t), (r.l = !0), r.exports;
//   }
//   (t.m = e),
//     (t.c = n),
//     (t.d = function (e, n, o) {
//       t.o(e, n) || Object.defineProperty(e, n, { enumerable: !0, get: o });
//     }),
//     (t.r = function (e) {
//       "undefined" != typeof Symbol &&
//         Symbol.toStringTag &&
//         Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
//         Object.defineProperty(e, "__esModule", { value: !0 });
//     }),
//     (t.t = function (e, n) {
//       if ((1 & n && (e = t(e)), 8 & n)) return e;
//       if (4 & n && "object" == typeof e && e && e.__esModule) return e;
//       var o = Object.create(null);
//       if (
//         (t.r(o),
//         Object.defineProperty(o, "default", { enumerable: !0, value: e }),
//         2 & n && "string" != typeof e)
//       )
//         for (var r in e)
//           t.d(
//             o,
//             r,
//             function (n) {
//               return e[n];
//             }.bind(null, r)
//           );
//       return o;
//     }),
//     (t.n = function (e) {
//       var n =
//         e && e.__esModule
//           ? function () {
//               return e.default;
//             }
//           : function () {
//               return e;
//             };
//       return t.d(n, "a", n), n;
//     }),
//     (t.o = function (e, n) {
//       return Object.prototype.hasOwnProperty.call(e, n);
//     }),
//     (t.p = ""),
//     t((t.s = 1234));
// })({
//   1234: function (e, n, t) {
//     "use strict";
//     t.r(n);
//     var o = t(16);
//     document.addEventListener("DOMContentLoaded", function (e) {
//       !(function () {
//         console.log("init"),
//           null != document.querySelector(".pagination") &&
//             new InfiniteAjaxScroll(".blog-posts", {
//               item: ".blog-item",
//               next: ".next",
//               pagination: ".pagination",
//           loadOnScroll: false,
//               trigger: {
//                 element: ".trigger",
//                 when: function (e) {
//                   return !0;
//                 },
//                 show: function (e) {
//                   e.style.opacity = "1";
//                 },
//                 hide: function (e) {
//                   e.style.opacity = "0";
//                 },
//               },
//             }).on("appended", o.a);          
//       })();
//     });
//   },
//   16: function (e, n, t) {
//     "use strict";
//     function o() {
//       try {
//         var e,
//           n = document.querySelectorAll(
//             "img[data-src]:not(.hidden):not(.fade-in):not(.img-leads), video:not(.not-lazy)"
//           );
//         document.querySelector("body");
//         "IntersectionObserver" in window
//           ? ((e = new IntersectionObserver(
//               function (e, n) {
//                 e.forEach(function (e) {
//                   e.intersectionRatio > 0 &&
//                     (t(e.target), n.unobserve(e.target));
//                 });
//               },
//               { rootMargin: "100px 0px", threshold: 0 }
//             )),
//             n.forEach(function (n) {
//               return e.observe(n);
//             }))
//           : (console.log(
//               "%cIntersection Observers not supported",
//               "color: red"
//             ),
//             n.forEach(function (e) {
//               return t(e);
//             }));
//         var t = function (e) {
//           if ("VIDEO" === e.tagName) {
//             var n = e.children,
//               t = !1;
//             n.forEach(function (e) {
//               "string" == typeof e.tagName &&
//                 "SOURCE" === e.tagName &&
//                 ((e.src = e.dataset.src), (t = !0));
//             }),
//               t &&
//                 (e.classList.add("fade-in"),
//                 e.load(),
//                 e.addEventListener("error", function (e) {
//                   console.log("Error while loading the video");
//                 }),
//                 e.addEventListener("loadeddata", function () {
//                   console.log("Video has started loading successfully!"),
//                     4 === e.readyState && e.play();
//                 }));
//           } else
//             e.classList.add("fade-in"),
//               (e.src = e.dataset.src),
//               null != e.dataset.srcset && (e.srcset = e.dataset.srcset);
//         };
//       } catch (e) {
//         console.log("Caught an error: lazyLoad() ", e);

//       }
//     }
//     t.d(n, "a", function () {
//       return o;
//     });
//   },
// });
//   $(window).on('ready',function(){
//     let ias = new InfiniteAjaxScroll(".blog-posts", {
//       item: ".blog-item",
//       next: ".next",
//       pagination: ".pagination",
//       loadOnScroll: false,
//       trigger: {
//         element: ".trigger",
//         when: function (e) {
//           return !0;
//         },
//         show: function (e) {
//           e.style.opacity = "1";
//         },
//         hide: function (e) {
//           e.style.opacity = "0";
//         },
//       }
//     });

//     ias.on('last', () => {
//            console.log('Users has reached the last page');
//   });

//   ias.on('page', (event) => {
//     // update the title
//     document.title = event.title;

//     // update the url
//     let state = history.state;
//     history.replaceState(state, event.title, event.url);
//   })
// })

document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '.blog-posts',
    pagination: '.trigger-wrapper',
    method: 'click',
    offset: 1000
  });
});

$('.template-blog #MainContent .blog-menu').css('top',$('.site-header .header-bottom').innerHeight())

$(window).on('resize', function(){
  $('.template-blog #MainContent .blog-menu').css('top',$('.site-header .header-bottom').innerHeight())
})